import React from "react";
import { colors } from "../../../utils/theme";
import styled from "styled-components";
import { useDataContex } from "../../../hooks/Context/PatientProvider";
import Icon from "../../../assets/icons/logo.svg";


const Container = styled.div`
  display: flex;
  width: 90%;
  margin: 0 auto;
  justify-content: center;
  box-shadow: 1px 1px 5px 1px #00000029;
  border-radius: 5px;
`;

const IconContainer = styled.div`
  width: 8%;
  background-color: ${colors.secondary};
  border-radius: 10px;
  
  @media (max-width: 1024px) {
    width: 15%;
  }

  @media (max-width: 768px) {
    border-radius: initial;
  }

  article {
    width: 100%;
    height: 100%;
    padding: 2.5rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 80%;
      height: 80%;
    }
  }
`;

const Section = styled.div`
  width: 92%;
  background-color: ${colors.blanco};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    text-align: center;
    padding-right: 4.5em;
    @media (max-width: 768px) {
      padding-right: 0;
    }
    color: ${colors.primary};
    font-size: 1.3rem;
    font-weight: bold;
    margin: 1rem 0;

    @media (max-width: 500px) {
      font-size: 1.1rem;
    }
  }
`;

const ContainerForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const FormInputInfo = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 20px;
  align-items: center;
  flex-direction: column;
  width: 22%;

  @media (max-width: 1024px) {
    width: 40%;
  }

  @media (max-width: 768px) {
    width: 95%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
  }

  input {
    width: 100%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;

const handleInputChange = (newValue) => {
  console.log("");
};

export const SectionProgrammed = () => {
  const { TimeData, CalendarData } = useDataContex();
  if (CalendarData.length === 0) {
    window.history.replaceState(null, "", "/apihub/agenda/PacienteNuevo");
    return;
  }

  const selectedHour = TimeData[0]?.appointmentTime?.field || 0;

  const formatHour = (hour) => {
    const displayHour = (hour % 12 === 0 ? 12 : hour % 12).toString();
    const amPm = hour < 12 ? "AM" : "PM";
    return displayHour + ":00 " + amPm;
  };

  const formatHour2 = (hour) => {
    const displayHour = (
      (hour - 1) % 12 === 0 ? 12 : (hour - 1) % 12
    ).toString();
    const amPm = hour < 12 ? "AM" : "PM";
    return displayHour + ":40 " + amPm;
  };

  const hourFinal = formatHour(selectedHour);
  const hourFinal2 = formatHour2(selectedHour);

  return (
    <Container>
      <IconContainer>
        <article>
          <img src={Icon} alt="" />
        </article>
      </IconContainer>

      <Section>
        <h3>SESIÓN PROGRAMADA</h3>

        <ContainerForm>
          <FormInputInfo>
            <label>HORA DE LLEGADA</label>
            <input
              type="text"
              value={hourFinal2}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>HORA DE ATENCIÓN</label>
            <input
              type="text"
              value={hourFinal}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>FECHA ATENCIÓN</label>
            <input
              type="text"
              value={CalendarData[0].DateCalendar.campo}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>
        </ContainerForm>
      </Section>
    </Container>
  );
};
